module.exports = __webpack_public_path__ + "static/california-condors-8302d689e879ce39aeb5b60e6224a950.jpg";